import { useState, useEffect } from 'react';
import { Stack, Container, Typography, Card, Box, Button } from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { getApi } from 'views/services/api';
import { useNavigate } from 'react-router';

const ViewInvoices = () => {
  const hotelId = JSON.parse(localStorage.getItem('hotelData')).hotelId;
  console.log("hotelId =>",hotelId);

  const navigate = useNavigate();

  const [invoiceData, setInvoiceData] = useState([]);
  const [reservationIds, setReservationId] = useState([]);

  
  const fetchInvoiceData = async()=> {
    try {
        console.log("in fetchInvoiceData ==>",`api/invoice/viewallinvoice/${hotelId}`);
        const response = await getApi(`api/invoice/viewallinvoice/${hotelId}`);
        console.log("response here =>",response);
        setInvoiceData(response?.data?.invoiceData);

        const reservationids = response.data.invoiceData.map(item => item.reservationId);
        console.log("Reservation IDs =>", reservationids);
        setReservationId(reservationids);

      } catch (error) {
        console.log(error);
      }
  } 
  console.log("fetchInvoiceData response=>",invoiceData);
  console.log("set ids ==>",reservationIds);


  const fetchSingleBillData = async () => {
    try {
      reservationIds.map(async (reservationId) => {
        const response = await getApi(`api/singleinvoice/view/${reservationId}`);
        console.log("for fetchSingleBillData res ==>",response);

        response?.data?.InvoiceData && setInvoiceData((prevData) => [...(prevData), ...response.data.InvoiceData]);
      });
    } catch (error) {
      console.log(error);
    }
  };

  console.log("ha ha ==>",invoiceData);
  

  useEffect(()=>{
    fetchInvoiceData();
  },[]);

  useEffect(() => {
    console.log("reservationIds=============>>>>>",reservationIds);
    if (reservationIds.length > 0) {
      fetchSingleBillData();
    }
  }, [reservationIds]);

  const handleGenerateBill = (billItem) => {
    console.log(billItem, 'billItem')
    if (billItem.type === "room" ||billItem.type === "food"  ) {
      navigate(`/roombill/view/${billItem._id}`);
    } else {
      navigate(`/singlebill/view/${billItem.reservationId}`);
    }
  };

  const columns = [

    {
      field: `invoiceNumber`,
      headerName: 'Invoice Number',
      flex: 2,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box>
            <Box onClick={() => handleGenerateBill(params?.row)}>{params.value}</Box>
          </Box>
        );
      }
    },
    {
      field: `name`,
      headerName: 'Name',
      flex: 2,
      cellClassName: ' name-column--cell--capitalize',

      renderCell: (params) => {
        return (
          <Box>
            <Box>{params.value}</Box>
            <div style={{ marginTop: '4px', fontSize: '12px', color: '#777' }}>{params.row.customerPhoneNumber}</div>
          </Box>
        );
      }
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 2
    },

    {
      field: 'type',
      headerName: 'Invoice Type',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.type ? params.value : 'Food+Room'}</Box>;
      }
    },
    {
      field: 'foodAmount',
      headerName: 'Food Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalFoodAmount
              ? `Rs ${params.row.totalFoodAmount}`
              : params.row.foodAmount
              ? `Rs ${params.row.foodAmount}`
              : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'roomRent',
      headerName: 'Room Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalRoomAmount ? `Rs ${params.row.totalRoomAmount}` : params.row.roomRent ? `Rs ${params.row.roomRent}` : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'advanceAmount',
      headerName: 'Advance Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalRoomAmount
              ? 'N/A'
              : params.row.advanceAmount
              ? `Rs ${params.row.advanceAmount}`
              : params.row.totalRoomAmount
              ? 'N/A'
              : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'discount',
      headerName: 'Discount',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.value ? `Rs ${params.value}` : ' N/A'}</Box>;
      }
    },
    {
      field: 'totalAmount',
      headerName: 'Total Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.totalAmount ? `Rs ${params.row.totalAmount}` : `Rs ${params.row.totalFoodAndRoomAmount}`}</Box>;
      }
    },
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Customer Invoices</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '500px', paddingTop: '15px' }}>
              <DataGrid
                rows={invoiceData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default ViewInvoices;
